/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import { Contract, ContractFactory, Overrides } from "@ethersproject/contracts";

import type { GyroLib } from "../GyroLib";

export class GyroLib__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(
    gyroFundAddress: string,
    externalTokensRouterAddress: string,
    overrides?: Overrides
  ): Promise<GyroLib> {
    return super.deploy(
      gyroFundAddress,
      externalTokensRouterAddress,
      overrides || {}
    ) as Promise<GyroLib>;
  }
  getDeployTransaction(
    gyroFundAddress: string,
    externalTokensRouterAddress: string,
    overrides?: Overrides
  ): TransactionRequest {
    return super.getDeployTransaction(
      gyroFundAddress,
      externalTokensRouterAddress,
      overrides || {}
    );
  }
  attach(address: string): GyroLib {
    return super.attach(address) as GyroLib;
  }
  connect(signer: Signer): GyroLib__factory {
    return super.connect(signer) as GyroLib__factory;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): GyroLib {
    return new Contract(address, _abi, signerOrProvider) as GyroLib;
  }
}

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "gyroFundAddress",
        type: "address",
      },
      {
        internalType: "address",
        name: "externalTokensRouterAddress",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "minter",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "Mint",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "redeemer",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "Redeem",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "_tokensIn",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "_amountsIn",
        type: "uint256[]",
      },
    ],
    name: "estimateMintedGyro",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "_tokensOut",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "_amountsOut",
        type: "uint256[]",
      },
    ],
    name: "estimateRedeemedGyro",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "externalTokensRouter",
    outputs: [
      {
        internalType: "contract BalancerExternalTokenRouter",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "fund",
    outputs: [
      {
        internalType: "contract GyroFundV1",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getReserveValues",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "address[]",
        name: "",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getSupportedPools",
    outputs: [
      {
        internalType: "address[]",
        name: "",
        type: "address[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getSupportedTokens",
    outputs: [
      {
        internalType: "address[]",
        name: "",
        type: "address[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "initializeOwner",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "_tokensIn",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "_amountsIn",
        type: "uint256[]",
      },
      {
        internalType: "uint256",
        name: "_minAmountOut",
        type: "uint256",
      },
    ],
    name: "mintFromUnderlyingTokens",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "_tokensOut",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "_amountsOut",
        type: "uint256[]",
      },
      {
        internalType: "uint256",
        name: "_maxRedeemed",
        type: "uint256",
      },
    ],
    name: "redeemToUnderlyingTokens",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_fundAddress",
        type: "address",
      },
    ],
    name: "setFundAddress",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_routerAddress",
        type: "address",
      },
    ],
    name: "setRouterAddress",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "_tokensIn",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "_amountsIn",
        type: "uint256[]",
      },
      {
        internalType: "uint256",
        name: "_minGyroMinted",
        type: "uint256",
      },
    ],
    name: "wouldMintChecksPass",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "_tokensOut",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "_amountsOut",
        type: "uint256[]",
      },
      {
        internalType: "uint256",
        name: "_maxGyroRedeemed",
        type: "uint256",
      },
    ],
    name: "wouldRedeemChecksPass",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "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";
